import jwt_decode from "jwt-decode";
import moment from 'moment'

import { toast } from "react-toastify";
import i18n from "./langsconfig/i18n";
import { convertToFormData } from './hooks/useFormData';


export const ToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const ValidatePhone = (mobile) => {
  return /^01[0125][0-9]{8}$/g.test(mobile)
}

export const ValidatePassword = (password) => {
  return /^(?=.*\d)(?=.*[a-z])(?=.*[@#$%!^&])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/g.test(password)
}


export const errToast = (msg) => toast.error(i18n.t(msg))
export const succToast = (msg) => toast.success(i18n.t(msg))

export const IsListNotEmpty = (List) => !!List?.length

export const ActiveLink = (path) => GetURLPath() == path ? "active" : ""


export const SetLocStorage = (key, value) => localStorage.setItem(key, value)

export const GetLocStorage = (key) => localStorage.getItem(key)
export const ClearLocStorageItem = (key) => localStorage.removeItem(key)


export const TrimInnerSpaces = (value) => value?.split(" ").join("")

export const FormatePhone = (value) => TrimInnerSpaces(value)?.split("").filter(i => i != "+")

export const ValidatePdf = (Path) => {
  let fileExtension = Path?.type
  let forImg = Path?.type.split('/')[0]
  let AllowedExtension = ['application/pdf']
  return AllowedExtension?.includes(fileExtension) || AllowedExtension?.includes(forImg)
}


export const GetURLPath = () => window.location.hash.slice(1)

export const validateImg = (Img) => {
  return Img?.type?.includes('image/')
}

export const ValidateSSN = (SSN) => {
  return /(2|3)[0-9][0-9](0[1-9]|1[0-2])(0[1-9]|(1|2)[0-9]|3[0-1])(01|02|03|04|05|06|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/g.test(SSN)
}

export const ValidateEmail = (email) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email)
}

export const GetRoleId = () => {
  if (!GetLocStorage("ut")) {
    return null
  } else {
    return JSON.stringify(jwt_decode(GetLocStorage("ut"))).split("role\":")[1].split(',')[0].split('"')[1]

  }
}
export const GetUserId = () => {
  if (!GetLocStorage("ut")) {
    return null
  } else {
    return JSON.stringify(jwt_decode(GetLocStorage("ut"))).split("nameidentifier\":")[1].split(',')[0].split('"')[1]

  }
}


export const CheckArabicText = (text) =>
  /^[\u0621-\u064A0-9\s:,\\()\-_,’،.]+$/.test(text);

export const CheckEnglishText = (text) =>
  /^[a-zA-Z0-9\s:,.’\\()-_*]*$/.test(text);

export const GetPrivileges = (authorizedPages, pageNumber) =>
  authorizedPages?.find(p => p.id === pageNumber)?.privileges


export const ValidateFieldLang = (text, type) => {
  if (Number(text) && type != 'Num')
    return false

  if (!Number(text) && type == 'Num' && text != '')
    return false

  else if (type == 'Ar' && text != '' && !CheckArabicText(text))
    return false

  else if (type == 'En' && text != '' && !CheckEnglishText(text))
    return false

  return true
}


export const handleDate = (date) => moment(date)?.isValid() ? moment(date).format('yyyy-MM-DD') : ""

export const ValidateEnglish = (text) => ValidateFieldLang(text, 'En')

export const ValidateArabic = (text) => ValidateFieldLang(text, 'Ar')

export const VaidateNumbers = (text) => ValidateFieldLang(text, 'Num')

export const FormateDate = (date, t) => {
  var timeDate = moment(date).format("YYYY/MM/DD  hh:mm A")
  return timeDate.replace('AM', t('AM')).replace('PM', t('PM'));

}

export const toolTipAtrributes = (name, position = "left", showToolTip = true) => {
  return showToolTip && !name ? {} :
    {
      "data-tooltip-id": "my-tooltip",
      "data-tooltip-content": i18n.t(name),
      "data-tooltip-place": position
    }
}

export const GetFormDataRes = convertToFormData;


export const SearchParamsLink = (searchData, customSearchData, tableFiller = { page: 0, pageSize: 25 }) => {
  let dataObject = {}
  Object.entries(searchData).forEach(([key, item]) => {
    if (item?.value) dataObject[key] = item?.value
  })

  dataObject = { ...dataObject, ...customSearchData, page: tableFiller?.page, pageLength: tableFiller?.pageSize }

  let searchLink = new URLSearchParams(dataObject).toString()

  searchLink = `?${searchLink}`

  return searchLink
}


export const ValueReferances = (value) => {

  if (Array.isArray(value)) return { type: 'array', length: value?.length, cleared: [] }

  if (typeof value == 'string' || !!Number(value)) return { type: typeof value, cleared: "" }

  if (typeof value == 'object') return { type: 'object', cleared: ClearObject(value) }

}

export const ClearObject = (obj) => {
  let tempObj = {}

  Object.entries(obj).entries(([key, val], index) => {
    tempObj[key] = ValueReferances(val)?.cleared
  }
  )
  return tempObj
}

export const Localizer = (List) => List?.map(item => ({ ...item, label: i18n.t(item?.label) }))